module.exports = __webpack_public_path__ + "static/media/stepOne.ccc0e791.png";